import { BaseDetailListComponent } from './../base-list-component-v2';
import { QueryParameter } from './../../base-models/query-parameter';
import { BaseInlineUpdateComponent } from './../base-inline-update-component';
import { ModelData } from './../../base-models/model-data';
import { BaseUpdateComponent } from './../base-update-component';
import { ListData } from './../../base-models/list-data';
import { ActivatedRoute } from '@angular/router';
import { BaseContainer } from './base-container';
import { BaseEntity } from './../../base-models/base-entity';
import { OnInit, Input, ViewChild, forwardRef } from '@angular/core';
import { InlineContainerService } from './services/inline-container.service';
import { UserService } from '../../base-services/user.service';
import { ParentProperty } from '../../base-models/parent-property';
import { List } from 'immutable';
import { BaseDetailListSum } from '../base-detail-list-sum';

export class BaseInlineContainer<T extends BaseEntity> extends BaseContainer<T> implements OnInit {
    constructor(
        protected inlineContainerService: InlineContainerService<T>,
        protected activatedRoute: ActivatedRoute,
        protected userService: UserService
    ){
        super(inlineContainerService, activatedRoute, userService);
    }

    @Input() set DetailModelData(value: ListData){
        //let modelData: ModelData = new ModelData(this.userService);
        //modelData.MainList = value;
        this.baseInlineUpdateComponent.ModelData = value;
    }
    @Input() set ParentPropertyName(value: string){
        //this.baseInlineUpdateComponent.ParentProperty.Name = value;
        this._parentPropertyName = value;
        this.setParentProperty();
    }
    @Input() set ParentPropertyValue(value: number){
        //this.baseInlineUpdateComponent.ParentProperty.Value = value;
        this._parentPropertyValue = value;
        this.setParentProperty();
    }
    @Input() set Parameters(value: List<List<QueryParameter>>){
        this.baseInlineUpdateComponent.Parameters = value;
        if (this.baseDetailListSum)
            this.baseDetailListSum.Parameters = value;
    }

    @ViewChild('baseInlineUpdate', /* TODO: add static flag */ {static: true}) baseInlineUpdateComponent: BaseInlineUpdateComponent<T>;
    @ViewChild('baseDetailListSum', /* TODO: add static flag */ {static: true}) baseDetailListSum: BaseDetailListSum<T>;
    @ViewChild('baseDetailList', /* TODO: add static flag */ {static: true}) baseDetailList: BaseDetailListComponent<T>;

    ngOnInit(){
        super.ngOnInit();

        this.inlineContainerService.ItemDeleted
            .subscribe(value => {
                if(value){
                    this.baseInlineUpdateComponent.baseUpdateComponent.Item = <T>{ ID: -1 };
                    this.baseInlineUpdateComponent.baseUpdateComponent.baseFormGroup.reset(this.baseInlineUpdateComponent.baseUpdateComponent.emptyMaster);
                    this.baseInlineUpdateComponent.baseUpdateComponent.SavedItem = this.baseInlineUpdateComponent.baseUpdateComponent.baseFormGroup.getRawValue();
                    this.baseInlineUpdateComponent.collapsed = true;
                }
            })
            
    }

    public _parentPropertyName: string;
    public _parentPropertyValue: number;

    private setParentProperty(){
        this.baseInlineUpdateComponent.ParentProperty = new ParentProperty(this._parentPropertyName, this._parentPropertyValue);
    }
}